import DialogModal from "../Dialog";
import { InawoXclusive } from "../Icons";
import styles from "./xclusiveFeatures.module.scss";

interface Props {
  isXclusiveFeaturesOpen: boolean;
  setIsXclusiveFeaturesOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const XclusiveFeaturesModal = ({
  isXclusiveFeaturesOpen,
  setIsXclusiveFeaturesOpen,
}: Props) => {
  return (
    <DialogModal
      open={isXclusiveFeaturesOpen}
      onOpenChange={setIsXclusiveFeaturesOpen}
    >
      <div className={styles.container}>
        <InawoXclusive />
        <img src="/inawo-xclusive-features.svg" alt="Inawo xclusive features" />
        <div className={styles.header__text}>
          <h3>Inawo Exclusive</h3>
          <p>for celebrities and the one percent</p>
        </div>
        {/* <h3>
          goes for{" "}
          <span className={styles.actual__price}>
            {getSymbolFromCurrency(currency ?? "")}
            {formatMoney(undiscounted_cost ?? 0)}
          </span>
          {"  "}
          <span className={styles.discount__price}>
            {getSymbolFromCurrency(currency ?? "")}
            {formatMoney(discounted_cost ?? 0)}
          </span>
          <span className={styles.discount__price}>$1600</span>
        </h3> */}
        <p>Comes with</p>
        <div className={styles.features__container}>
          <div className={styles.feature}>
            <img src="/limited-edition-website.svg" alt="limited-edition" />
            <p>
              Limited Edition Website{" "}
              <span>
                Crafted in collaboration with top celebrity designers—each
                template is a work of art, and only a handful are ever released
              </span>{" "}
            </p>
          </div>
          <div className={styles.feature}>
            <img src="/design-concierge.svg" alt="design-concierge" />
            <p>
              Personal Design Concierge{" "}
              <span>
                Work with a personal Inawo creative director to fine-tune your
                digital wedding experience
              </span>
            </p>
          </div>
        </div>
        <div className="align-center flex flex-col gap-[16px]">
          {/* <button
            className="mx-auto w-auto rounded-[10px] bg-[#34544F] px-[18px] py-[12px] font-medium text-[#ffffff]"
            type="button"
            onClick={() => {
              setIsXclusiveFeaturesOpen(false);
              setOpenPaymentFlow(true);
            }}
          >
            Pay {getSymbolFromCurrency(currency ?? "")}
            {formatMoney(discounted_cost ?? 0)} to Activate
          </button> */}
          <button
            className="m-auto w-[250px] rounded-lg border-2 border-[#9C9C9C] bg-none px-0 py-2 text-[15px] font-medium text-[#292D2D] transition duration-300 hover:bg-gray-400 hover:text-white"
            type="button"
            onClick={() => {
              setIsXclusiveFeaturesOpen(false);
            }}
          >
            <a
              href="https://wa.me/2348121817391?text=Hi%20🖐%20I'm%20interested%20in%20Inawo%20exclusive,%20what%20do%20I%20do%20next?"
              className=""
              target="_blank"
              rel="noreferrer"
            >
              I want to talk to my concierge
            </a>
          </button>
        </div>
      </div>
    </DialogModal>
  );
};

export default XclusiveFeaturesModal;
